import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/healthcare/hospital-profile";

export const Route = createFileRoute(
  "/admin/_modules/_healthcare/hospital-profile"
)({
  component: Page,
});
